var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 28,
  fill: "none",
  viewBox: "0 0 37 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M0 4.583A4.583 4.583 0 0 1 4.583 0h27.5a4.583 4.583 0 0 1 4.584 4.583v2.292H0zm0 6.875v11.459A4.584 4.584 0 0 0 4.583 27.5h27.5a4.583 4.583 0 0 0 4.584-4.583V11.458zm6.875 4.584h2.292a2.29 2.29 0 0 1 2.291 2.291v2.292a2.29 2.29 0 0 1-2.291 2.292H6.875a2.29 2.29 0 0 1-2.292-2.292v-2.292a2.29 2.29 0 0 1 2.292-2.291"
})));
export default SvgCard;